// extracted by extract-css-chunks-webpack-plugin
module.exports = {"header":"header___35ndi","body":"body___2OEzG"};